function Impressum() {
  return (
    <div className="container mt-4 background">
      <h1>Impressum</h1>

      <p>Angaben gemäß § 5 DDG</p>

      <p>
        Valeria Peschke
        <br />
        Strelitzstr. 12
        <br />
        12105 Berlin
      </p>

      <p>
        <strong>Kontakt:</strong>
        <br />
        Telefon: 0176-27169731
        <br />
        E-Mail:{" "}
        <a href="mailto:peschkeva@googlemail.com">peschkeva@googlemail.com</a>
      </p>

      <p>
        <strong>Hinweis zu Marken, Spotify-Inhalten und Bildnachweis</strong>
        <br />
        Ich betreibe diese Website als nicht-kommerzielles Fanprojekt im Rahmen
        einer Weiterbildung. „Die drei ???“ ist eine eingetragene Marke der
        Franckh-Kosmos Verlags-GmbH &amp; Co. KG. Alle über diese Seite
        dargestellten Hörspiel-Cover und Inhalte werden ausschließlich über die
        offizielle Spotify-API eingebunden und bleiben Eigentum der jeweiligen
        Rechteinhaber. Ich stehe in keiner vertraglichen oder wirtschaftlichen
        Verbindung zu Franckh-Kosmos, EUROPA/Sony Music oder Spotify. Das
        verwendete Favicon basiert auf einem Icon von{" "}
        <a
          href="https://www.flaticon.com/free-icon/wave_7759987"
          target="_blank"
          rel="noopener noreferrer"
        >
          Freepik (Flaticon)
        </a>
        .
      </p>

      <p>
        <strong>
          Verbraucherstreitbeilegung / Universalschlichtungsstelle
        </strong>
        <br />
        Ich nehme nicht an Streitbeilegungsverfahren vor einer
        Verbraucherschlichtungsstelle teil und bin dazu auch nicht verpflichtet.
      </p>

      <p>
        <strong>Haftungsausschluss:</strong>
        <br />
        <br />
        <strong>Haftung für Inhalte</strong>
        <br />
        Die Inhalte dieser Seiten habe ich mit größter Sorgfalt erstellt. Für
        die Richtigkeit, Vollständigkeit und Aktualität der Inhalte kann ich
        jedoch keine Gewähr übernehmen. Als Diensteanbieter bin ich gemäß § 7
        Abs. 1 DDG für eigene Inhalte auf diesen Seiten nach den allgemeinen
        Gesetzen verantwortlich. Nach §§ 8 bis 10 DDG bin ich als
        Diensteanbieter jedoch nicht verpflichtet, übermittelte oder
        gespeicherte fremde Informationen zu überwachen oder nach Umständen zu
        forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
        Verpflichtungen zur Entfernung oder Sperrung der Nutzung von
        Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt.
        Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der
        Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von
        entsprechenden Rechtsverletzungen werde ich diese Inhalte umgehend
        entfernen.
        <br />
        <br />
        <strong>Haftung für Links</strong>
        <br />
        Mein Angebot enthält Links zu externen Webseiten Dritter, auf deren
        Inhalte ich keinen Einfluss habe. Deshalb kann ich für diese fremden
        Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten
        Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten
        verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der
        Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte
        waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente
        inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete
        Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden
        von Rechtsverletzungen werde ich derartige Links umgehend entfernen.
        <br />
        <br />
        <strong>Urheberrecht</strong>
        <br />
        Die durch mich erstellten Inhalte und Werke auf diesen Seiten
        unterliegen dem deutschen Urheberrecht. Die Vervielfältigung,
        Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der
        Grenzen des Urheberrechtes bedürfen meiner schriftlichen Zustimmung.
        Downloads und Kopien dieser Seite sind nur für den privaten,
        nicht-kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser
        Seite nicht von mir erstellt wurden, werden die Urheberrechte Dritter
        beachtet und entsprechende Inhalte als solche gekennzeichnet. Solltest
        du trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitte
        ich um einen entsprechenden Hinweis. Bei Bekanntwerden von
        Rechtsverletzungen werde ich derartige Inhalte umgehend entfernen.
      </p>

      <p>
        Impressum von{" "}
        <a href="https://impressum-generator.de" rel="dofollow">
          Impressum-Generator.de
        </a>
        . Powered by{" "}
        <a href="https://www.kanzlei-hasselbach.de/" rel="nofollow">
          Franziska Hasselbach, Bonn
        </a>
        .
      </p>
      <br />
      <br />
    </div>
  );
}

export default Impressum;
